// Only deliberate user-facing errors are shown verbatim: the backend marks them with an
// extensions.code (USER_FACING, TOOL_CALL_BUDGET_EXCEEDED, schedule validation codes, ...).
// Anything uncoded — unexpected exceptions stringified by graphene, network errors — must not
// reach the user and falls back to the translated generic message.
export const graphqlErrorMessage = (error: any, fallback: string): string => {
    const gqlError = error?.graphQLErrors?.[0];
    return (gqlError?.extensions?.code && gqlError.message) || fallback;
};
